import {connect} from "react-redux";
import {Modal} from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import tapIcon from "../../../../services/TapIcon";
import Ax from "../../../../components/hoc/Ax";
import {toast} from "react-toastify";
import React from "react";
import {number} from "prop-types";
import swal from "sweetalert";
import { ORG_API_BASE_URL_2 } from "../../../../services/TapApiUrls";

class GeneralSetting extends AppBaseComponent {

    constructor(props) {
        super(props);

        
        this.initGeneralConfigFormData      =   {
            enable_fuel_feedin_economy           :    'N',
            enable_fuel_feedin_cl                :    'N'
        };

        this.configData                     =   [
            {
                key         :   'enable_fuel_feedin_economy',
                value       :   'Enable Fuel FeedIn Economy'
            },
            {   
                key         :   'enable_fuel_feedin_cl',
                value       :   'Enable Fuel FeedIn CounterLog'
            },
            {
                key         :   'activate_verification_fuel_feedin',
                value       :   'Enable Verification Process for Fuel Transaction (Asset & Fuel Station)'
            }
        ];

        this.state                          =   {
            generalConfigloading                :   false,
            general_config_list                 :   null,
            generalConfigFormData               :   {...this.initGeneralConfigFormData},
            editFormSubmiting                   :   false,
            current_key                         :   '',
            configData                          :   [],
        };

        this.settingEditUrl =   ORG_API_BASE_URL_2  + '/setting_edit';
        this.settingUrl     =   ORG_API_BASE_URL_2  + '/settings';

    }

    componentDidMount() {
        this.getGeneralSettingListing();
        this.editGeneralConfiguration        =        new Modal(document.getElementById('editGeneralConfigurationModal'), {keyboard: false, backdrop :false});
       
    }

    //functions for general configuration
      getGeneralSettingListing              =    ()           =>     {
        let params = {
            keys : [ 'enable_fuel_feedin_economy','enable_fuel_feedin_cl','activate_verification_fuel_feedin'],
        }
        this.setState({generalConfigloading : true})
        HttpAPICall.withAthorization('GET', this.settingUrl, this.props.access_token, {...params}, {}, (resp) => {
         this.setState({general_config_list  : resp.data.data})
        }).then(() => this.setState({generalConfigloading: false}));
    }

    editGeneralConfigurationInit          =    (key='')           =>     {

        this.setState({
            configData  :   this.configData.filter(d => d.key === key) 
        })

        this.editGeneralConfiguration.show();
        if(this.state.general_config_list) {
            let generalConfigFormData = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigFormData[name] = val;
                });
              }
              
            this.setState({generalConfigFormData : generalConfigFormData,current_key : key})
        }
    }

    submitGeneralConfigurationForm        =    (e)          =>     {
        e.preventDefault();
        this.setState({editFormSubmiting : true});
        HttpAPICall.withAthorization('PUT', this.settingEditUrl, this.props.access_token, {} , {
            'enable_fuel_feedin_economy' : this.state.generalConfigFormData.enable_fuel_feedin_economy,'enable_fuel_feedin_cl' : this.state.generalConfigFormData.enable_fuel_feedin_cl,
            'enable_fuel_feedin_economy' : this.state.generalConfigFormData.enable_fuel_feedin_economy,'activate_verification_fuel_feedin' : this.state.generalConfigFormData.activate_verification_fuel_feedin
        } , (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.editGeneralConfiguration.hide();
            this.getGeneralSettingListing();
        }).then(() => this.setState({editFormSubmiting: false}));
    }

    generalConfigurationJsx               =    ()           =>     {
        let general_config_list = this.state.general_config_list;
          return (<table className="table table-hover table-bordered my-4 ">
              <thead className="table-secondary">
                  <tr className="text-center">
                      <th scope="col" style={{ width: "5%" }}>S.No</th>
                      <th scope="col" className="text-start">Configuration</th>
                      <th scope="col" style={{ width: "25%" }} >Value</th>
                      <th scope="col" style={{ width: "10%" }} >Action</th>
                  </tr>
              </thead>
              <tbody>
                {
                    this.configData.map((data, i) => (
                        <tr className="text-center" key={data.key}>
                            <td>{i+1}</td>
                            <td className="text-start">{data.value}</td>
                            <td>{general_config_list && general_config_list[data.key] == 'Y' ? "Yes" : "No"}</td>
                            <td> <span className="dropdown">
                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a className="dropdown-item" role="button" onClick={() => this.editGeneralConfigurationInit(data.key)}>Edit</a></li>
                            </ul>
                            </span>
                            </td>
                        </tr>
                    ))
                }
              </tbody>
          </table>)
      }

    editGeneralConfigurationModalJsx      =    ()           =>     {
          
        return (
              <div className="modal fade" id="editGeneralConfigurationModal" tabIndex="-1">
                  <div className="modal-dialog modal-lg">
                      <div className="modal-content">
                          <div className="modal-header">
                              <h5 className="modal-title" id="addAssetModalLabel">Edit General Configuration</h5>
                          </div>
                          <form onSubmit={this.submitGeneralConfigurationForm}>
                              <div className="modal-body p-3">
                                {
                                    this.state.configData.map((data) => (
                                        <div className="row align-items-center mb-2 mt-2 px-2" key={data.key}>
                                            <div className="col-md-8">
                                                <label className="form-label">{data.value}</label>
                                            </div>
                                            <div className="col-md-2">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={data.key}
                                                        value="Y"
                                                        onChange={(e) => this.formInputHandler(e, "generalConfigFormData")}
                                                        checked={this.state.generalConfigFormData[data.key] == "Y"}
                                                    /> Yes
                                                </label>
                                            </div>
                                            <div className="col-md-2">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={data.key}
                                                        value="N"
                                                        onChange={(e) => this.formInputHandler(e, "generalConfigFormData")}
                                                        checked={this.state.generalConfigFormData[data.key] == "N"} /> No
                                                </label>
                                            </div>
                                        </div>
                                    ))
                                }
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" disabled={this.state.editFormSubmiting} data-bs-dismiss="modal">Close</button>
                                  <button type="submit" className="btn btn-primary" disabled={this.state.editFormSubmiting} >Save {this.state.editFormSubmiting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : null}</button>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          );
    }
   

  
    render                                  =     ()           =>     {
        return (<Ax>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">General Configuration</span>
            </div>
            {this.state.generalConfigloading ? <Loader />
                : this.generalConfigurationJsx()}

            {this.editGeneralConfigurationModalJsx()}
        </Ax>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token
    };
};

export default connect(mapStateToProps)(GeneralSetting);